// Default placeholder images for the application
export const DEFAULT_USER_PHOTO = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png';
export const DEFAULT_COMPANY_LOGO = 'https://cdn.pixabay.com/photo/2016/03/31/19/14/building-1294843_1280.png';